import * as Blockly from 'blockly';
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";
//import 'blockly/core/variables';
import { javascriptGenerator } from 'blockly/javascript';
import '../field-variable-actions';

export function BlocklyCategory_VARIABLES_magic(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.VARIABLES, name: name, contents: [] };
  //***** DEFINITIONEN */
  Blockly.defineBlocksWithJsonArray(
    [
      {
        "type": "RAGAI_SET_VAR",
        "message0": "🏷️ setze %1 auf %2",
        "args0": [
          {
            "type": "field_variable_actions",
            "name": "VAR",
            "variable": "meine Variable",
          },
          {
            "type": "input_value",
            "name": "VALUE",
          }
        ],
        "previousStatement": null,
        "nextStatement": null,
        "colour": BLOCKLY_COLORS.VARIABLES,
        "tooltip": "Legt eine eigene Variable an (falls noch nicht vorhanden) und setzt sie auf den angegebenen Wert. Über das Feld neben \"setze\" lässt sich die Variable auswählen, umbenennen oder löschen.",
      },
      {
        "type": "RAGAI_GET_VAR",
        "message0": "📦 hole %1",
        "args0": [
          {
            "type": "field_variable_actions",
            "name": "VAR",
            "variable": "meine Variable",
          }
        ],
        "output": null,
        "colour": BLOCKLY_COLORS.VARIABLES,
        "tooltip": "Gibt den aktuellen Wert der ausgewählten eigenen Variable zurück.",
      }
    ]);

  javascriptGenerator.forBlock['RAGAI_SET_VAR'] = function (block, generator) {
    const varName = block.workspace.getVariableMap().getVariableById(block.getFieldValue('VAR'))?.getName() ?? '???';
    const childBlock = block.getInputTargetBlock('VALUE');
    let valueCode = "''";
    if (childBlock) {
      const result = generator.blockToCode(childBlock);
      valueCode = Array.isArray(result) ? result[0] : result;
    }
    return `RAGAI.VARIABLES["${varName}"] = ${valueCode};\n`;
  };

  javascriptGenerator.forBlock['RAGAI_GET_VAR'] = function (block) {
    const varName = block.workspace.getVariableMap().getVariableById(block.getFieldValue('VAR'))?.getName() ?? '???';
    return [`RAGAI.VARIABLES["${varName}"]`, 0];
  };

  cat.contents = [
    BH.label("Eigene Variablen"),
    BH.withNested(
      {
        "kind": "block",
        "type": "RAGAI_SET_VAR",
      }, [{ forValue: "VALUE", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]),
    {
      kind: "block",
      type: "RAGAI_GET_VAR"
    }

  ];

  return cat;
}
